import { CreditsPlusIcon } from '@components/Icons/CreditsPlusIcon';
import { CheckCircleRounded, InfoOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import classNames from 'classnames';
import css from './CreditUsageSummary.module.scss';

interface CreditBadge {
  text: string;
  variant?: 'green' | 'red';
}

interface CreditUsageSummaryProps {
  cost: {
    label: string;
    tooltip?: string;
    items: CreditBadge[];
  };
  /**
   * Optional: omitted when the library's owner is billed rather than the current user. The cost
   * estimate above holds either way — it's a property of the media, not of a wallet — but
   * "remaining after" would be computed from a balance that isn't the one being charged.
   */
  remaining?: {
    label: string;
    items: CreditBadge[];
  };
}

export const CreditUsageSummary = ({ cost, remaining }: CreditUsageSummaryProps) => {
  return (
    <div className={css.creditUsageContainer}>
      <div className={css.creditUsageBlock}>
        <div className={css.creditUsageBlockLeft}>
          <CreditsPlusIcon />
          {cost.label}
          {cost.tooltip && (
            <Tooltip title={cost.tooltip} arrow>
              <InfoOutlined className={css.infoIcon} />
            </Tooltip>
          )}
        </div>
        <div className={css.creditUsageBlockRight}>
          {cost.items.map((item, i) => (
            <div
              key={i}
              className={classNames(css.creditsCount, item.variant && css[item.variant])}
            >
              {item.text}
            </div>
          ))}
        </div>
      </div>
      {remaining && (
        <div className={css.creditUsageBlock}>
          <div className={css.creditUsageBlockLeft}>
            <span className={classNames(css.svg, css.green, css.center)}>
              <CheckCircleRounded />
            </span>
            {remaining.label}
          </div>
          <div className={css.creditUsageBlockRight}>
            {remaining.items.map((item, i) => (
              <div
                key={i}
                className={classNames(css.creditsCount, item.variant && css[item.variant])}
              >
                {item.text}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
